import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";

// render - pages
const View = Loadable(lazy(() => import("../View")));
const InitialSupplier = Loadable(lazy(() => import("../InitialSupplier")));
const PurchaseOrder = Loadable(lazy(() => import("../PurchaseOrder")));
const InspectionTableByPurchaseOrderId = Loadable(
  lazy(() => import("./molecules/InspectionTableByPurchaseOrderId"))
);
const SupplierServiceProvider = Loadable(
  lazy(() => import("../SupplierServiceProvider"))
);
const NewSupplierReevaluationRecord = Loadable(
  lazy(() => import("../NewSupplierReEvaluationRecord"))
);

const RawMaterialDescription = Loadable(
  lazy(() => import("../RawMaterialDescription"))
);
const AccessoriesDescription = Loadable(
  lazy(() => import("../AccessoriesDescription"))
);
const PackagingMaterialDescription = Loadable(
  lazy(() => import("../PackagingMaterialDescription"))
);
const IncomingInspectionReport = Loadable(
  lazy(() => import("../IncomingInspectionReport"))
);
const SupplierAgreementRecord = Loadable(
  lazy(() => import("../SupplierAgreementRecord"))
);
const RequisitionSlipRecord = Loadable(
  lazy(() => import("../RequisitionSlipRecord"))
);
const IssueSlipRecords = Loadable(lazy(() => import("../IssueSlipRecords")));

const RawMaterialStockRegister = Loadable(
  lazy(() => import("../RawMaterialStockRegister"))
);
const SupplierEvaluatioRecords = Loadable(
  lazy(() => import("../SupplierEvaluatioRecords"))
);
const SubContractorAgreementRecord = Loadable(
  lazy(() => import("../SubContractorAgreementRecord"))
);
const ApproveSupplierRecords = Loadable(
  lazy(() => import("../ApproveSupplierRecords"))
);

// Helper function to create routes
const createRoute = (path, element, children) => ({ path, element, children });

// ==============================|| PAGE ROUTES ||============================== //
const newPurchaseRoute = [
  {
    path: routeConstants.PURCHASE,
    children: [
      { path: "intiateSuppliers", element: <InitialSupplier /> },
      {
        path: "view/:id/:supplierFormId?/:purchaseOrderId?",
        element: <View />,
      },
      {
        path: "supplier-service-provider",
        element: <SupplierServiceProvider />,
      },
      { path: "purchase-orders", element: <PurchaseOrder /> },
      {
        path: "inspectionTable/:purchaserOrderId",
        element: <InspectionTableByPurchaseOrderId />,
      },
      { path: "raw-material-description", element: <RawMaterialDescription /> },
      { path: "accessories-description", element: <AccessoriesDescription /> },
      {
        path: "packaging-material-description",
        element: <PackagingMaterialDescription />,
      },
      {
        path: "incomming-inspection-report",
        element: <IncomingInspectionReport />,
      },
      { path: "stock-register", element: <RawMaterialStockRegister /> },
      {
        path: "supplier-evaluation-record",
        element: <SupplierEvaluatioRecords />,
      },
      {
        path: "supplier-agreement-record",
        element: <SupplierAgreementRecord />,
      },
      { path: "requistion-slip-record", element: <RequisitionSlipRecord /> },
      { path: "issue-slip-record", element: <IssueSlipRecords /> },
      {
        path: "apporved-supplier-list-record",
        element: <ApproveSupplierRecords />,
      },
      {
        path: "supplier-reevaluation-record",
        element: <NewSupplierReevaluationRecord />,
      },

      {
        path: "subContractor-agreement-record",
        element: <SubContractorAgreementRecord />,
      },
    ],
  },
];

export default newPurchaseRoute;
